var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2582_58567)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2582_58567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5C4.34375 0.5 3 1.84375 3 3.5V8.5C3 10.1562 4.34375 11.5 6 11.5C7.65625 11.5 9 10.1562 9 8.5V3.5C9 1.84375 7.65625 0.5 6 0.5ZM2 7.25C2 6.83437 1.66562 6.5 1.25 6.5C0.834375 6.5 0.5 6.83437 0.5 7.25V8.5C0.5 11.2844 2.56875 13.5844 5.25 13.95V15H3.75C3.33437 15 3 15.3344 3 15.75C3 16.1656 3.33437 16.5 3.75 16.5H6H8.25C8.66562 16.5 9 16.1656 9 15.75C9 15.3344 8.66562 15 8.25 15H6.75V13.95C9.43125 13.5844 11.5 11.2844 11.5 8.5V7.25C11.5 6.83437 11.1656 6.5 10.75 6.5C10.3344 6.5 10 6.83437 10 7.25V8.5C10 10.7094 8.20937 12.5 6 12.5C3.79063 12.5 2 10.7094 2 8.5V7.25Z",
    fill: "#6B7280"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2582_58567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2582_58567"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H12V16.5H0V0.5Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceIcon);
export default __webpack_public_path__ + "static/media/voice-icon.e48396c19873869fea181b7d0e5933cd.svg";
export { ForwardRef as ReactComponent };